import { HttpStatusCode } from "axios";
import WidgetService from "../../apiServices/masters/wigetService";

import { setWidgets, setWidget, setQuickLinksWidget, setScholarshipWidget } from "../../store/slices/master/widgetSlice";
import { alertConstants } from "../../helper/sweet-alert";

export function getWidget(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.getWidget(id);
    if (response?.success === true) {
      dispatch(setWidget(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getWidgets(
  configUserRole?: number,
  pageBlockId?: number,
  collegeId?: number,
  noOfItems?: number
) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.getWidgets(
      configUserRole,
      pageBlockId,
      collegeId,
      noOfItems
    );
    if (response?.success === true) {
      if (pageBlockId === 9 && (collegeId == null || collegeId == undefined)) {
        dispatch(setScholarshipWidget(response.data));
      }
      else if ((pageBlockId === 21 || pageBlockId === 15) && (collegeId == null || collegeId == undefined)) {
        dispatch(setQuickLinksWidget(response.data));
      }
      else {
        dispatch(setWidgets(response.data));
      }
    } else {
      console.log("error");
    }
  };
}

export function createWidget(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.createWidget(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateWidget(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.updateWidget(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateWidgetPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.updateWidgetPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteWidget(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await WidgetService.deleteWidget(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
